import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showDialog, showErrorDialog, showSuccessDialog } from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchParameter,
  fetchParameter2,
  selectCountry,
  selectParameter,
  selectParameter2,
  selectPhoneType,
} from "../businessParameter/businessParameterSlice";
// MUI
import {
  makeStyles,
  fade,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { FormHelperText, InputAdornment } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import {
  selectCountryAll,
  selectMstaddresstype,
} from "../location/locationSlice";
import { v4 as uuidv4 } from "uuid";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },

  focused: {},
}));

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "1px !important", // Remove the margin
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
});

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const ModalAddress = ({
  isOpen,
  handleShow,
  setShowAddress,
  listAddress,
  setListAddress,
  dataRow,
  setDataRow,
  rowIndex,
  setRowIndex,
  formatExtraData,
  setFormatExtraData,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const dataPhoneType = useSelector(selectPhoneType);
  const dataCountry = useSelector(selectCountryAll);
  const dataAddress = useSelector(selectMstaddresstype);

  // initial

  const [formValues, setFormValues] = useState({
    address_type: {
      value: "41eb6acb-b810-4238-a16e-cabde72afbb2",
      error: false,
      required: "Y",
    },
    address_name: {
      value: "",
      error: false,
      required: "N",
    },
    first_name: {
      value: "",
      error: false,
      required: "N",
    },
    last_name: {
      value: "",
      error: false,
      required: "N",
    },
    address1: {
      value: "",
      error: false,
      required: "Y",
    },
    address2: {
      value: "",
      error: false,
      required: "N",
    },
    city: {
      value: "",
      error: false,
      required: "N",
    },
    zipcode: {
      value: "",
      error: false,
      required: "N",
    },
    country_id: {
      value: "",
      error: false,
      required: "Y",
    },
    country_name: {
      value: "ID",
      error: false,
      required: "Y",
    },
    province: {
      value: "",
      error: false,
      required: "N",
    },
    email: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const [fieldsCP, setFieldsCP] = useState([
    {
      phone_type: "",
      phone: "",
    },
  ]);

  useEffect(() => {
    if (dataRow !== null) {
      setFormValues({
        address_type: {
          value: dataRow.addresstype_id,
          error: false,
          required: "Y",
        },
        address_name: {
          value: "",
          error: false,
          required: "N",
        },
        first_name: {
          value: dataRow.cp_first_name,
          error: false,
          required: "N",
        },
        last_name: {
          value: dataRow.cp_last_name,
          error: false,
          required: "N",
        },

        address1: {
          value: dataRow.address1,
          error: false,
          required: "Y",
        },
        address2: {
          value: dataRow.address2,
          error: false,
          required: "N",
        },
        city: {
          value: dataRow.city,
          error: false,
          required: "N",
        },
        zipcode: {
          value: dataRow.zipcode,
          error: false,
          required: "N",
        },
        country_id: {
          value: dataRow.country_id,
          error: false,
          required: "Y",
        },
        country_name: {
          value: "ID",
          error: false,
          required: "Y",
        },
        province: {
          value: dataRow.province,
          error: false,
          required: "N",
        },
        email: {
          value: dataRow.cp_email,
          error: false,
          required: "N",
        },
      });

      setFieldsCP(dataRow.cps);
    }
  }, [dataRow]);

  const typePhone = dataPhoneType.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  function handlePhoneChange(i, event) {
    const values = [...fieldsCP];
    values[i].phone = event.target.value;
    setFieldsCP(values);
  }

  function handleAdd() {
    const values = [...fieldsCP];
    values.push({
      phone_type: "",
      phone: "",
    });
    setFieldsCP(values);
  }

  function handleRemove(i) {
    const values = [...fieldsCP];
    values.splice(i, 1);
    setFieldsCP(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fieldsCP];
    values[i].phone_type = event.value;
    setFieldsCP(values);
  };

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const countryOptions = dataCountry.map((e) => {
    return {
      value: e.country_id,
      label: e.country_name,
    };
  });

  const addressOptions = dataAddress.map((e) => {
    return {
      value: e.addresstype_id,
      label: e.addresstype_name,
    };
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleChangeCountry = (e, params) => {
    const value = params.value;
    const label = params.label;
    setFormValues({
      ...formValues,
      ["country_id"]: {
        ...formValues["country_id"],
        value,
      },
      ["country_name"]: {
        ...formValues["country_name"],
        value: label,
      },
    });
  };

  const handleChangeAddress = (e, params) => {
    const value = params.value;
    const label = params.label;
    setFormValues({
      ...formValues,
      ["address_type"]: {
        ...formValues["address_type"],
        value,
      },
      ["address_name"]: {
        ...formValues["address_name"],
        value: label,
      },
    });
  };

  console.log(formValues, "formValues ");

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      // uuid: uuidv4(),
      addresstype_id: formValues.address_type.value,
      addresstype_name: formValues.address_name.value,
      address1: formValues.address1.value,
      address2: formValues.address2.value,
      city: formValues.city.value,
      zipcode: formValues.zipcode.value,
      country_id: formValues.country_id.value,
      country_name: formValues.country_name.value,
      province: formValues.province.value,
      cp_first_name: formValues.first_name.value,
      cp_last_name: formValues.last_name.value,
      cp_email: formValues.email.value,
      cps: fieldsCP,
    };

    console.log(params);
    if (dataRow !== null) {
      const list = [...formatExtraData];

      list[rowIndex] = params;
      console.log(list, "aneh");

      setListAddress(list);
    } else {
      setListAddress([...listAddress, params]);
    }

    handleClose();
  };

  const icon = <SVG src={toAbsoluteUrl("/media/svg/icons/New/x-error.svg")} />;
  const index = countryOptions.findIndex(
    (obj) => obj.value === formValues.country_id.value
  );

  const indexAddress = addressOptions.findIndex(
    (obj) => obj.value === formValues.address_type.value
  );

  const handleClose = () => {
    setFormValues({
      address_type: {
        value: "",
        error: false,
        required: "Y",
      },
      address_name: {
        value: "",
        error: false,
        required: "N",
      },
      first_name: {
        value: "",
        error: false,
        required: "N",
      },
      last_name: {
        value: "",
        error: false,
        required: "N",
      },
      designation: {
        value: "",
        error: false,
        required: "N",
      },
      address1: {
        value: "",
        error: false,
        required: "Y",
      },
      address2: {
        value: "",
        error: false,
        required: "N",
      },
      city: {
        value: "",
        error: false,
        required: "N",
      },
      zipcode: {
        value: "",
        error: false,
        required: "N",
      },
      country_id: {
        value: "",
        error: false,
        required: "Y",
      },
      country_name: {
        value: "ID",
        error: false,
        required: "Y",
      },
      province: {
        value: "",
        error: false,
        required: "N",
      },
      email: {
        value: "",
        error: false,
        required: "N",
      },
    });

    setDataRow(null);
    setRowIndex(null);
    setFormatExtraData([]);
    setShowAddress(false);
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={isOpen}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter text-white">
          New Address
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ThemeProvider theme={formLabelsTheme}>
          <Row>
            <Col xs={12} sm={3} md={6} lg={6}>
              <Autocomplete
                disablePortal
                name="address_type"
                options={addressOptions}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                value={
                  addressOptions.find(
                    (option) => option.value === formValues.address_type.value
                  ) || null
                }
                onChange={(event, newValue) => {
                  if (newValue === null) {
                    setFormValues({
                      ...formValues,
                      ["address_type"]: {
                        ...formValues["address_type"],
                        value: "",
                      },
                    });
                  } else {
                    setFormValues({
                      ...formValues,
                      ["address_type"]: {
                        ...formValues["address_type"],
                        value: newValue.value,
                      },
                    });
                  }
                }}
                renderInput={(params) => (
                  <RedditTextField
                    required
                    className={classes.margin}
                    {...params}
                    label="Address Type"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    placeholder="Select Country"
                    name="address_type"
                    error={formValues.address_type.error}
                    helperText={
                      formValues.address_type.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {icon} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                )}
              />

              <RedditTextField
                inputProps={{ maxLength: 512 }}
                required
                label="Address Line 1"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                multiline
                rows="4"
                name="address1"
                value={formValues.address1.value}
                onChange={handleChange}
                error={formValues.address1.error}
                helperText={
                  formValues.address1.error ? (
                    <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                      {icon} {"This field is required"}
                    </FormHelperText>
                  ) : (
                    ""
                  )
                }
              />
              <RedditTextField
                label="Zipcode"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="zipcode"
                onChange={handleChange}
                value={formValues.zipcode.value}
              />
              <Autocomplete
                disablePortal
                name="country_id"
                options={countryOptions}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                value={
                  countryOptions.find(
                    (option) => option.value === formValues.country_id.value
                  ) || null
                }
                onChange={(event, newValue) => {
                  if (newValue === null) {
                    setFormValues({
                      ...formValues,
                      ["country_id"]: {
                        ...formValues["country_id"],
                        value: "",
                      },
                    });
                  } else {
                    setFormValues({
                      ...formValues,
                      ["country_id"]: {
                        ...formValues["country_id"],
                        value: newValue.value,
                      },
                    });
                  }
                }}
                renderInput={(params) => (
                  <RedditTextField
                    required
                    className={classes.margin}
                    {...params}
                    label="Country"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    placeholder="Select Country"
                    name="country_id"
                    error={formValues.country_id.error}
                    helperText={
                      formValues.country_id.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {icon} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                )}
              />
            </Col>
            <Col xs={12} sm={3} md={6} lg={6}>
              {" "}
              <RedditTextField
                label="City"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="city"
                onChange={handleChange}
                value={formValues.city.value}
              />
              <RedditTextField
                label="Address Line 2"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                multiline
                rows="4"
                name="address2"
                onChange={handleChange}
                value={formValues.address2.value}
              />
              <RedditTextField
                label="Province"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="province"
                onChange={handleChange}
                value={formValues.province.value}
              />
            </Col>
          </Row>
          <p className="font-weight-bold  m-3">Contact Details :</p>

          <Row>
            <Col xs={12} sm={3} md={6} lg={6}>
              <RedditTextField
                label="First Name"
                inputProps={{ maxLength: 128 }}
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="first_name"
                onChange={handleChange}
                value={formValues.first_name.value}
              />
            </Col>
            <Col xs={12} sm={3} md={6} lg={6}>
              <RedditTextField
                label="Last Name"
                inputProps={{ maxLength: 128 }}
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="last_name"
                onChange={handleChange}
                value={formValues.last_name.value}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={3} md={6} lg={6}>
              {fieldsCP.map((field, idx) => {
                return (
                  <div key={`${field}-${idx}`}>
                    <Row>
                      <Col md={4}>
                        <Select
                          // isClearable={true}
                          options={typePhone}
                          value={getValueType(field.phone_type, typePhone)}
                          placeholder="Type"
                          onChange={(e) => handleTypeChange(idx, e)}
                          className="mt-4 ml-3"
                        />
                      </Col>
                      <Col md={6}>
                        <RedditTextField
                          inputProps={{
                            maxLength: 20,
                            onInput: (e) => {
                              if (e.target.value.length > 20) {
                                e.target.value = e.target.value.slice(0, 20);
                              }
                            },
                          }}
                          label="Phone Number"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="number"
                          size="small"
                          fullWidth
                          value={field.phone || ""}
                          onChange={(e) => handlePhoneChange(idx, e)}
                        />
                      </Col>
                      {fieldsCP.length !== 1 && (
                        <Col>
                          <div
                            className="btn btn-icon btn-primary btn-hover-primary btn-sm mt-4 "
                            onClick={() => handleRemove(idx)}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-light">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/X.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                      <Col sm={1}>
                        {fieldsCP.length - 1 === idx && (
                          <Button
                            variant="outline-primary"
                            onClick={(e) => handleAdd()}
                            className="mt-4 "
                          >
                            Add
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </Col>

            <Col xs={12} sm={3} md={6} lg={6}>
              <RedditTextField
                label="Email"
                inputProps={{ maxLength: 128 }}
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                name="email"
                onChange={handleChange}
                value={formValues.email.value}
              />
            </Col>
          </Row>
        </ThemeProvider>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button onClick={handleSave} variant="primary">
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
